import { Box } from '@chakra-ui/react';

import { BentoLayout } from 'common/bento/lib/layout';
import { FCWithChildren } from 'common/types';
import Button from 'components/_core/Button';
import Card from 'components/_core/Card';
import Text from 'components/_core/Text';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import { AddressSchema } from '../../../../components/AddressForm/addressSchema';
import Header from '../../../../components/Header';
import FormattedAddress from '../../components/FormattedAddress';
import locales from './locales';

export interface ReviewAddressProps {
  onPrev: () => void;
  isLoading: boolean;
  onEditAddress: () => void;
  address: AddressSchema;
}

/**
 * A page that asks the user to confirm their address
 * and is meant to be used by other pages
 */
const ReviewAddress: FCWithChildren<
  ReviewAddressProps & {
    Layout: BentoLayout;
  }
> = ({
  address,
  children,
  isLoading,
  Layout,
  onEditAddress,
  onPrev,
  ...props
}) => (
  <Layout nav={<OBNavigation onPrev={onPrev} />} {...props}>
    <Box>
      <Header description={locales.description} title={locales.title} />
      <Text
        fontWeight="weight-500"
        marginBottom="space-16"
        size="lg"
        variant="primary"
      >
        1. {locales.subTitleCheckAddress}
      </Text>

      <Card marginBottom="space-48">
        <FormattedAddress address={address} />

        <Button
          marginRight="auto"
          marginTop="space-12"
          onClick={onEditAddress}
          variant="inline-secondary"
        >
          {locales.editAddress}
        </Button>
      </Card>

      {children}
    </Box>
  </Layout>
);

export default ReviewAddress;
